var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1057 10.3221C13.8242 10.3221 15.2174 8.92896 15.2174 7.21039C15.2174 5.49181 13.8242 4.09863 12.1057 4.09863C10.3871 4.09863 8.9939 5.49181 8.9939 7.21039C8.9939 8.92896 10.3871 10.3221 12.1057 10.3221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.109 19.3295C8.69702 19.3295 5.69445 18.7289 5.94012 17.2277C6.59522 13.297 8.64243 11.0042 12.109 11.0042C15.5756 11.0042 17.6228 13.3243 18.2779 17.2277C18.5236 18.7289 15.521 19.3295 12.109 19.3295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashUser);
export default __webpack_public_path__ + "static/media/dash-user.6e8a6ad2af868eededd98b91fc553aeb.svg";
export { ForwardRef as ReactComponent };